import { render, staticRenderFns } from "./PromotionTooltipInfo.vue?vue&type=template&id=f4323014&"
import script from "./PromotionTooltipInfo.vue?vue&type=script&lang=js&"
export * from "./PromotionTooltipInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports